import type React from "react";

import { cn } from "~/lib/utils";

interface PlpTopBannerProps {
  children?: React.ReactNode;
  attributes?: Record<string, unknown> & { className?: string };
}

export function PlpTopBanner({ children, attributes }: PlpTopBannerProps) {
  const { className, ...restAttributes } = attributes ?? {};
  return (
    <div className={cn("w-full", className)} {...restAttributes}>
      {children}
    </div>
  );
}
